import { atom, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { PosClientConfig } from 'src/WebApiController';

export const activeAccountAtom = atom<{
  webClientConfig: PosClientConfig | null;
}>({
  webClientConfig: null,
});

export const useRegisterActiveAccountAtom = (
  activeAccountWebClientConfig: PosClientConfig | null
) => {
  const setActiveAccount = useSetAtom(activeAccountAtom);
  useEffect(() => {
    setActiveAccount({
      webClientConfig: activeAccountWebClientConfig,
    });
  }, [activeAccountWebClientConfig, setActiveAccount]);
};
